export const HELP_AND_FAQ = "support:help and faq"

export const ARTICLE_LIST_CLICK = "article list:article click"

export const SEARCH_RESULTS_PRODUCT_NAVIGATION =
  "search results product navigation"

export const SEARCH_RESULTS = "search results"

export const MAIN_CONTENT_AREA = "main content area"

export const SEARCH_TYPE = {
  RESOURCES: "resources",
  INSPIRATION: "inspiration",
}
